// eslint-disable-next-line
import _bingads_webui_static_legacy_utils_date from '@bingads-webui-static-legacy/utils/date';
// eslint-disable-next-line
const { dateUtil } = _bingads_webui_static_legacy_utils_date;

const frequency = {
  DAILY: 0,
  WEEKLY: 1,
  MONTHLY: 2,
  ONCE: 3,
  HOURLY: 4,
};

export function getFrequency(Cron, cronFormatter) {
  const i18n = window.globalLegacyI18n.get('module/extension/requirejs/i18n!global');
  let ret = '';
  const model = cronFormatter.parse(Cron);
  if (model) {
    const hourString = i18n.getString(`DailyOptions_${model.hour}`);
    let date;
    switch (model.frequency) {
      case frequency.ONCE:
        ret = i18n.getString('Frequency_WeeklyTemplate').replace('{0}', i18n.getString('FrequencyGrain_Once'));
        date = new Date(model.year, model.month - 1, model.dayOfMonth, 0, 0, 0, 0);
        ret = ret.replace('{1}', dateUtil.format(date));
        ret = ret.replace('{2}', hourString);
        break;
      case frequency.MONTHLY:
        ret = i18n.getString('Frequency_MonthlyTemplate').replace('{0}', i18n.getString('FrequencyGrain_Monthly'));
        ret = ret.replace('{1}', model.dayOfMonth);
        ret = ret.replace('{2}', hourString);
        break;
      case frequency.WEEKLY:
        ret = i18n.getString('Frequency_WeeklyTemplate').replace('{0}', i18n.getString('FrequencyGrain_Weekly'));
        ret = ret.replace('{1}', i18n.getString(`WeeklyOptions_${model.dayOfWeek}`));
        ret = ret.replace('{2}', hourString);
        break;
      case frequency.DAILY:
        ret = i18n.getString('Frequency_DailyTemplate').replace('{0}', i18n.getString('FrequencyGrain_Daily'));
        ret = ret.replace('{1}', hourString);
        break;
      case frequency.HOURLY:
        ret = i18n.getString('FrequencyGrain_Hourly');
        break;
      default:
        throw new Error();
    }
  }
  // if (rule.TimeZoneId > 0) {
  //   ret += '<br>';
  //   ret += i18n.getString(`TimeZoneId_${rule.TimeZoneId}`);
  // }
  // if (rule.Selection && rule.Selection.DateRange && rule.Selection.DateRange.DateRangePreset) {
  //   ret += '<br><br>';
  //   ret += i18n.getString('DataDateRange_Template').replace('{0}', i18n.getString(`DataDateRangeOptions_${rule.Selection.DateRange.DateRangePreset}`).toLowerCase());
  // }
  return ret;
}
